// extracted by mini-css-extract-plugin
module.exports = {"storiesrhswidget":"QZ4ps","storiesbigimg":"aLlxk","storieslistrhs":"OYYfm","moreLink":"esnMz"};